'use client'

import { AboutIport } from '@/screens/AboutIport'

const AboutIportPageContent = () => {
	return <AboutIport />
}

export function AboutIportClient() {
	return <AboutIportPageContent />
}
